import { useRouter } from '@savvy/deprecated-shared/hooks/use-router';
import { getAuthHeader } from '@savvy/deprecated-shared/utils/savvy-auth';

export function useInviteTokenHeaders() {
  const router = useRouter();
  const { inviteToken } = router.query;
  let headers = {};
  if (inviteToken) {
    headers = {
      authorization: getAuthHeader(router),
    };
  }
  return headers;
}
